export default {"src":"/_next/static/media/logo.73c9dddf.svg","height":41,"width":193,"blurWidth":0,"blurHeight":0};